import RestauranteMotoristaService from "@/services/RestauranteMotoristaService";

export const restauranteMotorista = {
  namespaced: true,
  state: {
    restauranteMotorista: {},
  },
  actions: {
    getRestauranteMotorista({ commit }, payload) {
      return RestauranteMotoristaService.GetRestauranteMotorista(payload).then(
        (motorista) => Promise.resolve(motorista),
        (error) => Promise.reject(error.response.data)
      );
    },
    postRestauranteMotorista({ commit }, payload) {
      return RestauranteMotoristaService.PostRestauranteMotorista(payload).then(
        (motorista) => Promise.resolve(motorista),
        (error) => Promise.reject(error.response.data)
      );
    },
    putRestauranteMotorista({ commit }, payload) {
      return RestauranteMotoristaService.PutRestauranteMotorista(payload).then(
        (motorista) => Promise.resolve(motorista),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteRestauranteMotorista({ commit }, payload) {
      return RestauranteMotoristaService.DeleteRestauranteMotorista(
        payload
      ).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    getRestauranteMotoristaOData({ commit }, payload) {
      return RestauranteMotoristaService.GetRestauranteMotoristaOData(
        payload
      ).then(
        (motorista) => Promise.resolve(motorista),
        (error) => Promise.reject(error)
      );
    },
  },
  mutations: {},
};

export default restauranteMotorista;
